import React from 'react';

interface App {
  id: string;
  name: string;
  description: string;
  icon: string;
  url: string;
  status: 'active' | 'coming-soon' | 'maintenance' | 'development';
  brands: string[];
  category: string;
  lastUpdated: string;
  external?: boolean;
}

interface AppCardProps {
  app: App;
}

const AppCard: React.FC<AppCardProps> = ({ app }) => {
  const handleClick = () => {
    if (app.status === 'active') {
      if (app.external) {
        window.open(app.url, '_blank');
      } else {
        window.location.href = app.url;
      }
    }
  };

  const getBrandColors = () => {
    const colors: { [key: string]: string } = {
      'mars-men': '#FF6B35',
      'hollow-socks': '#4A90E2',
      'easy-street': '#2ECC71',
    };
    return app.brands.map(brand => colors[brand] || '#666');
  };

  const getStatusText = () => {
    switch (app.status) {
      case 'active': return null;
      case 'coming-soon': return 'Coming Soon';
      case 'development': return 'In Development';
      case 'maintenance': return 'Under Maintenance';
      default: return app.status;
    }
  };

  const getStatusClass = () => {
    return `app-card ${app.status}`;
  };

  return (
    <div 
      className={getStatusClass()} 
      onClick={handleClick}
      role={app.status === 'active' ? 'button' : undefined}
      tabIndex={app.status === 'active' ? 0 : undefined}
    >
      <div className="app-header">
        <div className="app-icon">{app.icon}</div>
        <div className="app-brands">
          {getBrandColors().map((color, index) => (
            <span 
              key={index} 
              className="brand-dot" 
              style={{ backgroundColor: color }}
              title={app.brands[index]}
            />
          ))}
        </div>
      </div>
      
      <h3 className="app-name">{app.name}</h3>
      <p className="app-description">{app.description}</p>
      
      <div className="app-footer">
        <span className="app-category">{app.category}</span>
        {getStatusText() && (
          <span className="app-status">{getStatusText()}</span>
        )}
      </div>
      
      {app.status === 'active' && (
        <div className="app-hover-action">
          <span>{app.external ? 'Open External →' : 'Launch Tool →'}</span>
        </div>
      )}
      {app.external && (
        <div className="external-indicator">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5 1.5L1.5 10.5M10.5 1.5H4.5M10.5 1.5V7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      )}
    </div>
  );
};

export default AppCard;